const mediaItems = [
  {
    id: 1,
    title: '《春日华尔兹》最新预告',
    category: '韩剧 · 爱情',
    duration: '2:15',
    views: '128万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20romantic%20drama%20scene%20with%20soft%20cherry%20blossom%20and%20couple%20walking%20under%20warm%20spring%20sunlight%2C%20Japanese%20Korean%20drama%20aesthetic%2C%20soft%20pastel%20tones%2C%20dreamy%20atmosphere%2C%20film%20grain%20texture%2C%20editorial%20cinematography&width=800&height=450&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《暗影追踪》第三季开播',
    category: '日剧 · 悬疑',
    duration: '1:48',
    views: '96万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20thriller%20scene%20with%20rainy%20urban%20alley%20and%20detective%20silhouette%2C%20neon%20light%20reflections%20on%20wet%20pavement%2C%20Japanese%20crime%20drama%20aesthetic%2C%20moody%20cinematography%2C%20suspenseful%20atmosphere&width=800&height=450&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《江户物语》特别篇上线',
    category: '日剧 · 古装',
    duration: '3:02',
    views: '215万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20historical%20Japanese%20period%20drama%20scene%20with%20traditional%20architecture%20and%20kimono%2C%20warm%20lantern%20light%2C%20autumn%20maple%20leaves%2C%20cinematic%20composition%2C%20soft%20golden%20hour%20lighting%2C%20refined%20atmosphere&width=800&height=450&seq=media-card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《首尔恋爱指南》高甜混剪',
    category: '韩剧 · 喜剧',
    duration: '4:20',
    views: '189万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20romantic%20comedy%20scene%20with%20couple%20in%20modern%20Seoul%20cafe%2C%20warm%20sunlight%20through%20large%20windows%2C%20Korean%20drama%20aesthetic%2C%20pastel%20color%20palette%2C%20joyful%20uplifting%20mood%2C%20clean%20modern%20production%20design&width=800&height=450&seq=media-card-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            精彩预告
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            最新日韩电视剧预告片与精彩混剪，抢先感受下一部必追好剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-300"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white text-xs whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <span className="text-xs text-primary-600 font-medium whitespace-nowrap">{item.category}</span>
                <h3 className="mt-1.5 text-sm font-semibold font-heading text-foreground-950 line-clamp-2">
                  {item.title}
                </h3>
                <div className="mt-2 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}